import PropTypes from 'prop-types';

import { Text } from '../../../../shared/components';
import IconCircle from '../IconCircle';
export default function OverviewCard({ icon, title, value }) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <IconCircle icon={icon} />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'flex-start',
          marginLeft: 15,
        }}
      >
        <Text.small weak>{title}</Text.small>
        <Text.h2 color="var(--color-blue-primary)">
          {value.toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false,
          })}
        </Text.h2>
      </div>
    </div>
  );
}

OverviewCard.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
};
